import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { Branch } from 'graphql/models/generated';
import { BranchBasicInfoComponent } from 'shared/forms/branch/basic-info/basic-info.component';
import { SettingsService } from 'shared/services/settings.service';

@Component({
  selector: 'app-branch-basic-info-modal',
  templateUrl: './basic-info-modal.component.html',
  styleUrls: ['./basic-info-modal.component.scss']
})
export class BranchBasicInfoModalComponent {
  @ViewChild(BranchBasicInfoComponent) branchBasicInfoComponent!: BranchBasicInfoComponent;

  get form(): UntypedFormGroup {
    return this.branchBasicInfoComponent.form;
  }

  constructor(
    private settingsService: SettingsService
  ) { }

  onSubmit(): Observable<Branch> {
    return this.settingsService.createBranchWithLogo(this.form.value);
  }
}
